import { useState, useEffect } from "react";
import { RESPONSE_STATUS } from "../../../../utils/constants";
import fetchTaskCount from "./fetchTaskCount";
import fetchOpportunityCount from "./fetchOpportunityCount";
import fetchActivityCount from "./fetchActivityCount";
import { widgetTypes } from "../../../../utils/constants";

const apiMap = {
  [widgetTypes.ACTIVITES]: fetchActivityCount,
  [widgetTypes.TASKS]: fetchTaskCount,
  [widgetTypes.OPPORTUNITIES]: fetchOpportunityCount,
};
const initialize = async (setCount, config) => {
  setCount({
    responseStatus: RESPONSE_STATUS.requestPending,
    data: null,
  });
  try {
    const api = apiMap[config.widgetType];
    if (!api)
      throw new Error(`No API found for widget type: ${config.widgetType}`);
    const response = await api(config);
    setCount({
      responseStatus: RESPONSE_STATUS.requestFullfilled,
      data: response,
    });
  } catch (error) {
    console.error(error);
    setCount({
      responseStatus: RESPONSE_STATUS.requestRejected,
      data: null,
    });
  }
};
const useCount = (config) => {
  const [count, setCount] = useState({
    responseStatus: RESPONSE_STATUS.requestPending,
    data: null,
  });

  useEffect(() => {
    initialize(setCount, config);
  }, [config]);
  return {
    initialize: () => initialize(setCount, config),
    loading: count.responseStatus === RESPONSE_STATUS.requestPending,
    error: count.responseStatus === RESPONSE_STATUS.requestRejected,
    count: count.data,
  };
};

export default useCount;
